import { toastError } from '@components/Toast';

import * as actionTypes from '@store/salesContract/action-types';

import ApiClient from '@lib/apiClient';

export const fetchSalesContractDetails = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getSalesContractDetails', id);
		dispatch({
			type: actionTypes.FETCH_SALES_CONTRACT_DETAILS_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_SALES_CONTRACT_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};
